// ** React Imports
import React, { Fragment } from 'react'

// ** Custom Components
import NavbarUser from './NavbarUser'
import * as Icon from 'react-feather'
import MediaQuery from 'react-responsive'

const ThemeNavbar = props => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props

  return (
    <Fragment>
      <div className='d-flex align-items-center'>
        <MediaQuery maxWidth={1199}>
          <div className='nav-menu-toggle' onClick={() => setMenuVisibility(true)}><Icon.Menu className='ficon' /></div>
        </MediaQuery>
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  )
}

export default ThemeNavbar
